'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hydrateClientState = exports.HYDRATE_CLIENT_STATE = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var HYDRATE_CLIENT_STATE = exports.HYDRATE_CLIENT_STATE = 'HYDRATE_CLIENT_STATE';

/* ACTION CREATORS */
var hydrateClientState = exports.hydrateClientState = function hydrateClientState(params) {
    return {
        payload: (0, _extends3.default)({}, params),
        type: HYDRATE_CLIENT_STATE
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/client.js
// module id = 7TbR
// module chunks = 60